import {Backbone} from 'Vertebrae';
import {Calendar} from '../model/calendar';

export const Calendars = Backbone.Collection.extend({
    _name: 'Calendars',
    model: Calendar,
});
